import { toEpochMilliseconds } from "@/lib/time/toEpochMilliseconds"

export const isSameTime = (
  a: string | number | Date,
  b: string | number | Date
) => {
  return toEpochMilliseconds(a) === toEpochMilliseconds(b)
}
